<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="goBack(0)"></i>订单详情
    </div>
    <cube-scroll class="header-scroll">
      <div class="order-details clearfix">
        <div class="user-order">
          <div class="user-header">
            <!-- <div class="header-wrap">
            </div> -->
            <img v-if="order.PayType == 1" class="order_icon" src="../assets/images/bankIcon.png" alt="">
            <img v-if="order.PayType == 2" class="order_icon" src="../assets/images/alipayIcon.png" alt="">
          </div>
          <div class="order-amount-time">
            <!-- <div class="order-amount">{{common.toDecimal2(order.USDT)}} USDT</div> -->
            <!-- <div class="order-time"><span>交易 10</span>&nbsp;&nbsp;<span>好评 {{order.buyerScore}}%</span></div> -->
          </div>
        </div>
        <div class="order-money">
          <div class="order-money-title">金额</div>
          <div class="order-money-amount">
            <span v-clipboard:copy="common.toDecimal2(order.CNY)" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ common.toDecimal2(order.CNY) }}</span>CNY
          </div>
        </div>
      </div>
      <div class="separator"></div>
      <div class="order-info">
        <!-- <div class="page-item">
	  			<span class='page-item-label'>订单号：</span>
	  			<span class="page-item-content">{{params.order.orderNo}}</span>
        </div>-->
        <!-- <div class="page-item">
          <span class="page-item-label">USDT：</span>
          <span class="page-item-content">{{order.USDT}}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">价格：</span>
          <span class="page-item-content">{{order.Price}}</span>
        </div> -->
        <div class="page-item">
          <span class="page-item-label">下单时间：</span>
          <span class="page-item-content">{{ order.OrderTime ? common.formatDate(order.OrderTime) : '' }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">系统订单号：</span>
          <span class="page-item-content" v-clipboard:copy="order.OrderNo" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ order.OrderNo }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">商户订单号：</span>
          <span class="page-item-content" v-clipboard:copy="order.MchOrder" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ order.MchOrder }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款人：</span>
          <span class="page-item-content">{{ order.BankUser }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款人备注：</span>
          <span class="page-item-content" v-clipboard:copy="order.BankRemark" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ order.BankRemark }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款账号：</span>
          <span class="page-item-content">{{ order.BankAccount }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">打款人：</span>
          <span class="page-item-content" v-clipboard:copy="order.PayName" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ order.PayName }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">状态：</span>
          <span class="page-item-content">{{ getStatus(order) }}</span>
        </div>
        <div class="page-item" v-if="order.PayType == 2">
          <span class="page-item-label">客户付款凭证：</span>
          <span class="page-item-content">
            <span v-if="order.PaymentImg">
              <img style="width: 100px;height: 120px;margin: 10px 0;" v-for="(img, index) in imgs" :key="img" :src="img"
                @click="handleImgsClick(index)">
            </span>
            <span v-if="!order.PaymentImg">
              未上传
            </span>
          </span>
        </div>
        <div class="page-item" v-if="differ > 0 && (status == 1 || status == 2)">
          <span class="page-item-label">剩余时间：</span>
          <span class="page-item-content">{{ restTime }}</span>
        </div>
        <div v-if="order.PayType == 2" class="account-wrap" style="padding:14px 0px">
          <div class="wrap-item" style="padding-left: 14px;">
            <span class="item-label">付款方式：</span>
            <div class="radio-wrap">
              <cube-radio-group @input="changeStatus" v-model="payRemark" :options="typeOptions" :horizontal="true" />
            </div>
          </div>
        </div>
      </div>
      <!--6=退返中；5=异议单；2=待确认 1=待付款   -->
      <div v-if="status == 6 || status == 5 || status == 2">
        <div class="auth-upload">
          <div class="upload-title">上传未收款凭证</div>
          <div class="upload-wrap">
            <cube-upload class="box-wrap" ref="frontUpload" v-model="auth.file1" :auto="false" :max="1"
              @files-added="filesAdded" @file-success="successFront" @file-error="errFront">
              <div class="clearfix">
                <div class="startImg" v-if="startFileFlag1">
                  <img :src="startFile1" alt="" />
                  <i class="cubeic-wrong" @click="closeStart('file1')"></i>
                </div>
                <cube-upload-file v-for="(file, i) in auth.file1" :file="file" :key="i"></cube-upload-file>
                <cube-upload-btn :multiple="false">
                  <div class="upload-btn">
                    <i></i>
                    <p>点击此处上传凭证1</p>
                  </div>
                </cube-upload-btn>
              </div>
            </cube-upload>
            <cube-upload class="box-wrap" ref="backPpload" v-model="auth.file2" :auto="false" :max="1"
              @files-added="filesAdded" @file-success="successFront" @file-error="errFront">
              <div class="clearfix">
                <div class="startImg" v-if="startFileFlag2">
                  <img :src="startFile2" alt="" />
                  <i class="cubeic-wrong" @click="closeStart('file2')"></i>
                </div>

                <cube-upload-file v-for="(file, i) in auth.file2" :file="file" :key="i"></cube-upload-file>
                <cube-upload-btn :multiple="false">
                  <div class="upload-btn">
                    <i></i>
                    <p>点击此处上传凭证2</p>
                  </div>
                </cube-upload-btn>
              </div>
            </cube-upload>
          </div>
        </div>
        <div class="order-operation">
          <div class="tusd-btn  tusd-btn-danger" @click="updloadProof">未收到款，确认提交</div>
          <div v-if="status == 6 || status == 5" class="tusd-btn" @click="returnconfirmGet" v-show="!cfmClick">已收到款，确认收款
          </div>
          <div v-if="status == 2" class="tusd-btn" @click="confirmGet" v-show="!cfmClick">已收到款，确认收款</div>
        </div>
      </div>
      <div v-if="status == 1">
        <div class="order-operation">
          <div class="tusd-btn" @click="confirmGet" v-show="!cfmClick">确认收款</div>
          <!-- <div class="tusd-btn tusd-btn-danger" @click="noGet" v-show="!cfmClick">没有收到款项</div> -->
        </div>
        <div class="notice">
          友情提示：
          <br />1. 请核对收款信息后再“确认收款”；
          <br />2. 如果没有收到款项，倒计时结束后订单会进入退返流程。请上传收款账户流水截图，会有专人处理未付款订单；
          <br />3. 如果您在订单处于“退返中”状态时收到款项。请在订单-出售-全部，找到该订单进行“确认收款”；
          <br />4. 任何情况下收到款，请及时“确认收款”，避免影响未来的接单。
        </div>
      </div>
      <!-- 已关闭订单且承兑是不需要审核退返订单 才会显示此功能-->
      <div class="order-operation" v-if="confirmCloseOrderStatus">
        <div class="tusd-btn" @click="closeConfirmGet" v-show="!cfmClick">已收到款，确认收款</div>
      </div>
      <!-- 新增：跳转到交易凭证页面按钮 -->
      <div v-if="status == 3" class="order-operation">
        <div class="tusd-btn" @click="goVoucher">查看交易凭证</div>
      </div>
        <div v-if="status != 3 && order.PayType == 2" class="order-operation">
        <div class="tusd-btn tusd-btn-danger" @click="goOrderQrCodeDetail">查看收款账号二维码</div>
      </div>
    </cube-scroll>
  </div>
</template>

<script>
import '../config';

export default {
  name: "orderDetails",
  data() {
    return {
      lastCrtIndex: 0,
      defalutimg: _defaultimg_,
      differ: 0,
      restTime: "",
      popupTxt: "",
      cfmClick: false,
      noClick: false,
      params: {},
      order: {},
      status: 0,
      confirmCloseOrderStatus: false,
      auth: {
        file1: [],
        file2: []
      },
      apiURL: _APIURL_,
      imgURL: _IMGURL_,
      startFile1: '',
      startFile2: '',
      startFileFlag2: false,
      startFileFlag1: false,
      timer: 0,
      nowTime: 0,
      nextTime: 0,
      coutTime: 0,
      imgs: [],
      initialIndex: 0,
      payRemark: 1,
      typeOptions: [
        {
          label: "转账",
          value: 1
        },
        {
          label: "花呗",
          value: 2
        }
      ],
    };
  },
  methods: {
    goOrderQrCodeDetail() {
      let name = 'orderQrCodeDetail', that = this;
			that.$store.commit('storeParams', {
        name: name,
        params: {
            BankUser : that.order.BankUser,
            BankRemark : that.order.BankRemark,
            BankAccount : that.order.BankAccount,
            AmountType : that.order.AmountType,
            QRCodeUrl : that.order.QRCodeUrl,
            TransferQRCodeUrl : that.order.TransferQRCodeUrl,
            CreditQRCodeUrl : that.order.CreditQRCodeUrl
          }
			})
      that.$router.push({ name: name })
    },
    goVoucher() {
      let name = 'voucher', that = this;
			that.$store.commit('storeParams', {
           name: name,
				   params: {
              Amount: that.order.CNY,
              price: that.order.Price,
              usdt: that.order.USDT,
              paytype: that.order.PayType,
              bankName: that.order.BankName,
              bankAccount: that.order.BankAccount,
              payName: that.order.PayName,
              OrderNo: that.order.OrderNo,
              OrderTime: that.order.OrderTime ? that.common.formatDate(that.order.OrderTime) : ''
        }
			})
    	that.$router.push({ name: name })
    },
    copySuccess() {
      this.$message.popup("复制成功", 1000);
    },
    copyError() {
      this.$message.popup("复制失败", 1000);
    },
    filesAdded(files) {
      let hasIgnore = false;
      const limitSize = 2 * 1024 * 1024;
      // 最大5M
      const maxSize = 5 * 1024 * 1024;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true;
          hasIgnore = true;
          break;
        }
        // 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
        if (file.size > limitSize) {
          this.compressPic(file);
        } else {
          let reads = new FileReader();
          reads.readAsDataURL(file);
          let that = this;
          reads.onload = function (e) {
            var bdata = this.result;
            file.base64 = bdata;
          };
        }
      }
      hasIgnore &&
        this.$createToast({
          type: "warn",
          time: 1000,
          txt: "图片最大支持5M"
        }).show();
    },
    // 图片压缩方法
    compressPic(file) {
      let reads = new FileReader();
      reads.readAsDataURL(file);
      // 注意这里this作用域的问题
      reads.onload = function (e) {
        var bdata = this.result;
        // 这里quality的范围是（0-1）
        var quality = 0.5;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();
        img.src = bdata;
        img.onload = function () {
          var width = img.width;
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let data = canvas.toDataURL("image/jpeg", quality);
          file.base64 = data;
        };
      };
    },
    filesRemoved() {
    },
    successFront() {
    },
    errFront() {
    },
    changeStatus(v) {
      this.payRemark = v;
    },
    handleImgsClick(index) {
      this.initialIndex = index
      const params = {
        $props: {
          imgs: this.imgs,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    handleSingelImgClick(imgUrl) {
      this.$createImagePreview({
        imgs: [imgUrl]
      }).show()
    },
    getOrderDetail(orderId, tag) {
      let that = this;
      that.$api.getOrderDetail(orderId).then(res => {
        // console.log(res)
        that.order = res.data;
        that.payRemark = res.data.PayRemark == 0 ? 1 : res.data.PayRemark;
        if (res.data.PayImage1.indexOf(".") > 0) {
          this.startFileFlag1 = true
          that.startFile1 = res.data.PayImage1 + "?" + Math.random();
        }
        if (res.data.PayImage2.indexOf(".") > 0) {
          this.startFileFlag2 = true
          that.startFile2 = res.data.PayImage2 + "?" + Math.random();
        }

        that.status = that.order.Status;
        // that.common.countDownOrder(that, that.order.OutTimestamp);
        that.confirmCloseOrderStatus = that.order.ConfirmCloseOrderStatus
        that.countDownOrder(that, that.order.OutTimestamp);

        that.imgs = []
        that.imgs.push(that.order.PaymentImg)


        // console.log(that);
      });
    },
    countDownOrder(vue, differ) {
      vue.differ = differ
      this.timer = setInterval(function () {
        vue.restTime = vue.common.restTime(vue.differ)
        if (vue.differ <= 0) {
          clearInterval(this.timer)
          return false
        } else {
          vue.differ--
        }
      }, 1000)
      // !function run(vue){
      // }(vue)
    },
    getStatus(order) {
      let l
      _ORDERSTATUS_.some(s => {
        if (order.Status == s.value) {
          l = s.label
          return true
        }
      })
      return l
    },
    goBack(type) {
      let that = this;
      let crtIndex = that.$store.state.routerStore.orderDetails.crtIndex;
      if (type !== 0) {
        crtIndex = type;
      }
      that.$router.push({
        name: that.params.back,
        params: {
          crtIndex: crtIndex
        }
      });
    },
    goChat(orderId) {
      let name = 'chat', that = this;
      that.$store.commit('storeParams', {
        name: name,
        back: "",
        orderId: orderId
      })
      that.$router.push({ name: name })
    },
    returnconfirmGet() {
      let that = this;
      that.$message.confirm("提示", "确认前请仔细核对收款信息!您确定要确认收款？", () => {
        let data = { key: this.order.ID, payRemark: this.payRemark };
        that.$api.returnToconfirmOrder(data).then(res => {
          that.$message.popup("确认收款成功", 1000);
          // 弹出框之后跳回去
          that.goBack(0);
        });
      });
    },
    closeConfirmGet() {
      let that = this;
      that.$message.confirm("提示", "确认前请仔细核对收款信息!您确定要确认收款？", () => {
        let data = { key: this.order.ID, payRemark: this.payRemark };
        that.$api.closeToconfirmOrder(data).then(res => {
          that.$message.popup("确认收款成功", 1000);
          // 弹出框之后跳回去
          that.goBack(0);
        });
      });
    },
    confirmGet() {
      let that = this;
      that.$message.confirm("提示", "<p>确认前请仔细核对收款信息!</p><p>确认收款？</p>", () => {
        let data = { key: this.order.ID, payRemark: this.payRemark };
        that.$api.confirmOrder(data).then(res => {
          that.$message.popup("确认收款成功", 1000);
          // 弹出框之后跳回去
          that.goBack(0);
        });
      });
    },
    updloadProof() {
      let that = this;
      if (that.auth.file1.length > 0 || that.auth.file2.length > 0) {

        let data = {
          orderId: this.order.ID,
          pic1: that.auth.file1.length > 0 ? that.auth.file1[0].file.base64 : "",
          pic2: that.auth.file2.length > 0 ? that.auth.file2[0].file.base64 : ""
        };
        that.$message.confirm("提示", "确认上传未收款流水凭证？", () => {
          that.$api.updloadAction(data).then(res => {
            that.$message.popup("保存成功", 1000);
            // 弹出框之后跳回去
            that.goBack(0);
          });
        });
      } else {
        that.$message.popup("请至少上传一张未收款凭证", 1000);
        return;
      }

    },
    noGet() {
      let that = this;
      that.$message.confirm("提示", "您确定没有收到款？", () => {
        let data = { key: this.order.ID };
        that.$api.disputeOrder(data).then(res => {
          that.$message.popup("确定没有收到款成功", 1000);
          // 弹出框之后跳回去
          that.goBack(0);
        });
      });
    },
    closeStart(tag) {
      if (tag == 'file1') {
        this.startFileFlag1 = false
      } else {
        this.startFileFlag2 = false
      }
    }
  },
  created() {
    this.params = this.$store.state.routerStore.orderDetails;
    this.getOrderDetail(this.params.orderId);
    var that = this
    document.addEventListener('visibilitychange', function () {
      // console.log(document)
      if (document.visibilityState == 'visible') {
        that.nowTime = parseInt(new Date().getTime() / 1000)
        // console.log(that.nowTime)
        that.coutTime = parseInt(new Date(that.order.OutTime).getTime() / 1000)
        // console.log(that.coutTime - that.nowTime)
        var difftime = that.coutTime - that.nowTime
        if (difftime > 0) {
          that.countDownOrder(that, difftime)
        } else {
          clearInterval(that.timer)
        }
        // console.log('页面不可见');
      } else {
        // console.log(that.order.OutTime);
        if (that.timer) {
          clearInterval(that.timer)
        }
      }
    });


  }
};
</script>

<style lang="less" scoped>
.order-details {
  position: relative;
  padding: 20px 14px;

  .user-order {
    display: flex;
    align-items: center;
    float: left;
    width: 50%;

    .user-header {
      .header-wrap {
        width: 42px;
        height: 42px;
        margin-right: 16px;
        background: url(../assets/images/header.png) center center no-repeat;
        background-size: cover;
        border-radius: 20px;
      }
    }

    .order-amount {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }

    .order-time {
      span {
        display: inline-block;
        font-size: 12px !important;
        color: #96abe4;
      }
    }
  }

  .order-money {
    float: right;
    max-width: 50%;

    .order-money-title {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }

    .order-money-amount {
      font-size: 14px !important;
      color: #96abe4;

      span {
        margin-right: 10px;
        font-size: 22px !important;
        color: #28faff;
      }
    }
  }
}

.order-operation {
  margin: 26px 14px 12px;
  padding-bottom: 26px;
  border-bottom: 1px solid rgba(76, 89, 145, 0.6);
}

.notice {
  padding: 0px 14px 16px;
  color: #575f8d;
  font-size: 12px !important;
  line-height: @notice-height;
}
</style>
<style lang="less">
.cube-popup-center .cube-popup-content {
  padding: 12px 30px;
  border-radius: 3px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}

.cube-dialog-icon i {
  width: auto;
  height: auto;
}
</style>
<style lang="less">
.auth-upload {
  padding: 14px 14px 5px 14px;
  overflow: hidden;

  .upload-title {
    font-size: 15px !important;
    color: #d9e3fd;
  }

  .upload-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .box-wrap {
      width: 48.5%;
      height: 110px;
      padding: 0px;

      .upload-btn {
        padding-top: 14%;
        text-align: center;

        &.pic {
          float: left;
          width: 50%;
        }

        i {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url(../assets/images/add.svg) center center no-repeat;
        }

        p {
          padding-top: 10px;
          color: #8092c6;
        }
      }

    }
  }

  .upload-notice {
    margin: 14px 0px 36px;
    font-size: 12px !important;
    color: #575f8d;
    line-height: @notice-height;
  }
}

.cube-upload-file-def {
  width: 100%;
  height: 120px;
  z-index: 99;
}

.cube-popup-center .cube-popup-content {
  top: -60%;
}

.startImg {
  width: 100%;
  height: 120px;
  position: relative;
  z-index: 999;

  img {
    width: 100%;
    height: 100%;
  }
}

.cubeic-wrong {
  position: absolute;
  z-index: 2;
  top: -2px;
  right: -2px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
  background-color: #fff;
  border-radius: 50%;
}

.cubeic-wrong::before {
  display: inline-block;
  -webkit-transform: scale(1.625);
  transform: scale(1.625);
  -webkit-transform-origin: center;
  transform-origin: center;
}

@media screen and (min-width: 380px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 120px;
      }
    }
  }
}

@media screen and (max-width: 370px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 105px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 94px;

        .upload-btn {
          p {
            font-size: 13px !important;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.cube-popup-center .cube-popup-content {
  padding: 12px 30px;
  border-radius: 3px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}

.cube-dialog-icon i {
  width: auto;
  height: auto;
}

.upload-btn.pic {
  float: left;
  width: 50%;

  .picc {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #8092c6;

    img {
      max-width: 150px;
      margin: 0 auto;
      margin-bottom: 15px;
    }

    p {
      font-size: 12px !important
    }
  }
}

.cube-upload-btn {
  position: absolute;
  overflow: hidden;
  width: 100%;
  top: 2%;
}

.imgs-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.imgs-container img {
  width: 120px;
  margin: 20px 20px 20px 20px;
}

.order_icon {
  width: 38px;
  height: 38px;
  margin-right: 15px;
  border-radius: 50px;
}
</style>

<style lang="less">
.pay-remark {
  color: white;
  margin-left: -70px;
}

.radio-wrap {
  display: inline-block;

  .cube-radio-group {
    background-color: transparent;

    &:after {
      border: none;
    }

    .cube-radio {
      &:after {
        border: none;
      }
    }

    .cube-radio-ui {
      &:before {
        color: #8092c6;
      }
    }

    .cube-radio_selected {
      .cube-radio-ui {
        background-color: #00a0de;

        &:before {
          color: #00a0de;
        }

        i {
          &:before {
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);
            background: url(/images/selected.png) center center no-repeat;
            background-size: 76%;
          }
        }
      }
    }

    .cube-radio-label {
      color: #d9e3fd;
    }
  }
}
</style>